import type React from "react";
import { useDrag } from "react-dnd";
import style from "./DraggableElement.module.scss";

type DraggableProps = {
	card: { word: string; index: number };
};

export const DraggableElement: React.FC<DraggableProps> = ({ card }) => {
	const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
		type: "matchWordWithPic",
		item: { card },
		canDrag: () => Boolean(card.word),
		collect: (monitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
	}));
	return isDragging ? (
		<div ref={dragPreview} />
	) : (
		<button
			type="button"
			className={style.draggableElement}
			ref={drag}
			key={card.word}
		>
			{card.word}
		</button>
	);
};
